import service, { HttpResponseSuccess } from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

// eslint-disable-next-line
export const sendAnalytics = (
	payload: any
): Promise<HttpResponseSuccess<unknown>> | null => {
	if (sessionStorage.admin_token) return null;

	const payloadWithEnv = {
		...payload,
		properties: {
			...payload.properties,
			env: process.env.ENV_ID || process.env.REACT_NODE_ENV
		}
	};

	return apiService.post('/api/analytics/new', payloadWithEnv);
};

export const sendPublicAnalytics = (
	payload: any
): Promise<HttpResponseSuccess<unknown>> | null => {
	if (sessionStorage.admin_token) return null;

	const payloadWithEnv = {
		...payload,
		properties: {
			...payload.properties,
			env: process.env.ENV_ID || process.env.REACT_NODE_ENV
		}
	};

	return apiService.post('/api/analytics/public/new', payloadWithEnv);
};
